export enum CustomFieldFilterOptions {
    None = 1,
    DeletedCustomFields = 2,
    CaseType = 3
}

export enum CustomFieldSearchOptions {
    Question = 1
}
